import { render, staticRenderFns } from "./goout.vue?vue&type=template&id=b16947c0&scoped=true"
import script from "./goout.vue?vue&type=script&lang=js"
export * from "./goout.vue?vue&type=script&lang=js"
import style0 from "./goout.vue?vue&type=style&index=0&id=b16947c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16947c0",
  null
  
)

export default component.exports